export const getRandomInt = (min: number, max: number) => {
  return Math.floor(Math.random() * (max - min + 1)) + min
}

export const calculateAccumulatedMoney = (serviceDays: number, isFemale = false): number => {
  let money = 0
  let femaleAllowance = 0

  // https://intti.fi/paivaraha-ja-varusraha
  for (let day = 0; day < serviceDays; day++) {
    if (day < 165) {
      money += 5.9
    } else if (day < 255) {
      money += 9.8
    } else if (day < 347) {
      money += 13.65
    }

    if (isFemale) {
      femaleAllowance += 1.5
    }
  }

  return isFemale ? money + femaleAllowance : money
}
